import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { Constants } from '../../../endPoints';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Corrected import


const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;

  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(<i key={`full-${i}`} className="fa-solid fa-star text-orange-400 mr-1"></i>);
  }

  if (halfStar) {
    stars.push(<i key="half" className="fa-regular fa-star-half-stroke text-orange-400 mr-1"></i>);
  }

  while (stars.length < 5) {
    stars.push(<i key={`empty-${stars.length}`} className="fa-regular fa-star text-orange-400 mr-1"></i>);
  }

  return stars;
};

export default function Newproducts() {
  const [newArrivalProducts, setNewArrivalProducts] = useState([]);

  const [userId, setUserId] = useState(null);



  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        let userId = null;
        const token = localStorage.getItem('authToken');
        if (token) {
          const decoded = jwtDecode(token);
          userId = decoded.id;
          setUserId(userId);
        }
  
        const [productsRes, wishlistRes] = await Promise.all([
          axios.get(Constants.getNewArrivalProducts),
          userId ? axios.get(`${Constants.getUserWishlist}/${userId}`) : Promise.resolve({ data: { list: [] } }),
        ]);
  
        const products = productsRes.data.list || productsRes.data.data || [];
        const wishlist = wishlistRes.data.list || [];
  
        const wishlistIds = wishlist.map(item => item.idProduct); // adjust key if different
  
        const merged = products.map(p => ({
          ...p,
          isWishlist: wishlistIds.includes(p.id),
        }));
  
        setNewArrivalProducts(merged);
      } catch (error) {
        console.error('Error fetching new arrivals or wishlist:', error.message);
      }
    };
  
    fetchNewArrivals();
  }, []);


  const toggleWishlist = async (productId, isWished) => {
    try {
      if (!userId) return alert('Please log in to manage wishlist.');
  
      if (isWished) {
        await axios.delete(`${Constants.deleteFromWishlist}/${productId}`, {
          data: { idUser: userId }
        });
      } else {
        await axios.post(Constants.addToWishlist, { idUser: userId, idProduct: productId });
      }
  
      // Update local state
      setNewArrivalProducts((prev) =>
        prev.map((item) =>
          item.id === productId ? { ...item, isWishlist: !isWished } : item
        )
      );
    } catch (err) {
      console.error('Error updating wishlist:', err.message);
    }
  };
  
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2   ,
          slidesToScroll: 1,
        },
      },
    ],
};

  return (
    <section className="pt-5 pb-8 productSlide">
      <div className="container mx-auto px-4">
        <h2 className="headningfont lg:text-5xl text-3xl text-[#B3902D] capitalize mb-10 text-center">New Arrivals</h2>
        <Slider {...settings}>
          {newArrivalProducts.map((product) => (
            <div key={product.id} className="text-center md:px-2 px-1 h-full">
              <div className="md:p-3 p-2 border relative h-full hover:border-gray-400 transition-all">
              <button
                  className="absolute top-3 right-3 text-lg text-gray-300 hover:text-[#B3902D]"
                  onClick={() => toggleWishlist(product.id, product.isWishlist)}
                >
                  {product.isWishlist ? (
                    <i className="fa-solid fa-heart text-[#B3902D]"></i>
                  ) : (
                    <i className="fa-regular fa-heart"></i>
                  )}
                </button>
                <Link to={`/details/${product.id}`}>
                  <img
                    src={product.imageWithUrl}
                    className="mx-auto p-4 aspect-square object-contain max-h-60"
                    alt={product.selectionName}
                  />
                </Link>
                <h5 className="mb-3 text-xs tracking-widest">{renderStars(product.rating)}</h5>
                <h3 className="mb-3 uppercase md:tracking-wider md:text-base text-xs">
                  <Link to={`/details/${product.id}`}>{product.selectionName} {product.categoryName}</Link>
                </h3>
                {/* <h4 className="md:text-lg text-sm mb-2 flex gap-3 justify-center">
                  <span className="text-[#B3902D] font-semibold">${product.price}</span>
                </h4> */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
